import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { translate } from 'react-i18next'
import { withRouter } from 'react-router-dom'

import { firebaseAuth } from '../../firebase'
import AuthModal from './AuthModal'

import { Button, Avatar, Dropdown, Menu, Modal, Icon } from 'antd'

class Auth extends React.Component {
  state = {
    showModal: false,
    iconLoading: false,
    forgotPasswordView: false
  }

  forgotPasswordChange = value => {
    this.setState({
      forgotPasswordView: value
    })
  }

  handleModal = () => {
    this.setState(state => ({
      showModal: !state.showModal
    }))
    this.forgotPasswordChange(false)
  }

  logout = () => {
    firebaseAuth.signOut().then(() => {
      this.props.history.push('/')
      window.location.reload()
    })
  }

  profile () {
    alert('Profile not available yet. Please, try again later.')
  }

  render () {
    const { showModal, forgotPasswordView } = this.state
    const { t, user } = this.props

    const renderMenu = (
      <Menu>
        <Menu.Item key='0'>
          <Link to='/settings'><Icon type='setting' /> {t('settings.title')}</Link>
        </Menu.Item>
        <Menu.Item key='1'>
          <a onClick={() => this.logout()}><Icon type='logout' /> {t('logout')}</a>
        </Menu.Item>
        {/* just for testing */}
        {process.env.NODE_ENV !== 'production' &&
          <Menu.Item key='testing' className='testing'>
            {user && user.data.email} <br />
            {user && user.data.uid}
          </Menu.Item>}
      </Menu>
    )

    return (
      <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center' }}>
        {user
          ? <Dropdown overlay={renderMenu} trigger={['click']}>
            <Avatar src={user.data.photoURL} style={{ cursor: 'pointer' }} size='large'>
              {user.data.email.substring(0, user.data.email.indexOf('@'))}
            </Avatar>
          </Dropdown>
          : <Button type='primary' onClick={this.handleModal}>
            <Icon type='login' /> Login
            </Button>}

        <Modal visible={showModal && !user} onCancel={this.handleModal} width='600px' footer={null}>
          <AuthModal forgotPasswordChange={this.forgotPasswordChange} forgotPasswordView={forgotPasswordView} />
        </Modal>

      </div>
    )
  }
}

// =====================================
//  REDUX CONNECT
// -------------------------------------

const mapStateToProps = state => ({
  user: state.user,
  nav: state.nav
})

export default connect(mapStateToProps)(translate('translations')(withRouter(Auth)))



// WEBPACK FOOTER //
// ./src/components/Auth/index.js